/* @flow strict */

import * as React from 'react';

export const DefaultContainerContext = React.createContext({
  profileCurrent: {},
  filterEventDashboard: [0, 'type']
});
